angular
  .module('fca-used', [
    'ngSanitize',
    'ngTouch',
    'ngGuid',
    'ui.router',
    'pascalprecht.translate',
    'debounce',
    'rzModule',
    'ngStorage',
    'ngclipboard',
    'hl.sticky',
    'EnergyLabel',
    'angular-bind-html-compile',
    'ngMask'
  ])
  /* eslint-disable angular/window-service */
  .constant('CONFIG', window.FCAUsedConfig)
  .constant('moment', window.moment)
  /* eslint-enable angular/window-service */
  .run(["$window", "$location", "CONFIG", function ($window, $location, CONFIG) {
    $window.FCAUsedVersion = 'v1.18.5';
    CONFIG.search.mileage.min = CONFIG.search.mileage.steps[0];
    CONFIG.search.mileage.max = CONFIG.search.mileage.steps[CONFIG.search.mileage.steps.length - 1];
    if (!CONFIG.queryStringParams) {
      return CONFIG;
    }
    var qs = $location.search();
    if (qs[CONFIG.queryStringParams.defaultDistance]) {
      var defaultDistance = $window.parseInt(qs[CONFIG.queryStringParams.defaultDistance]) || NaN;
      if (!$window.isNaN(defaultDistance)) {
        $window.FCAUsedConfig.search.distance.default = defaultDistance;
      }
    }

    if (qs[CONFIG.queryStringParams.defaultModel]) {
      try {
        var defaultModel = angular.fromJson(qs[decodeURIComponent(CONFIG.queryStringParams.defaultModel)]);
        $window.FCAUsedConfig.search.model = {
          defaultModel: defaultModel
        };
      } catch (error) {
        $window.console.error('Unable to parse defaultModel');
      }
    }

    if (qs[CONFIG.queryStringParams.defaultLocation]) {
      try {
        $window.FCAUsedConfig.search.location = angular.fromJson(qs[CONFIG.queryStringParams.defaultLocation]);
      } catch (error) {
        $window.console.error('Unable to parse defaultLocation');
      }
    }

    if (qs[CONFIG.queryStringParams.goToResults]) {
      $window.FCAUsedConfig.search.goToResults = qs[CONFIG.queryStringParams.goToResults] === 'true';
    }

    CONFIG.search.volume = CONFIG.search.volume || {
      min: 0,
      max: 20,
      step: 1,
      unit: 'mc'
    };

    return CONFIG;
  }]);
